<div class="header-title">
    <div class="flex u-align-items-center u-pa-20">
        <div class="flex flex-align-center">
            <a routerLink="/button" aria-label="back"
                class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
                <span class="u-icon icon-chevron-left"></span>
                <span class="u-button-text">Back</span>
            </a>
        </div>
        <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
            <h1 class="font-semibold u-ma-0 flex header-title--name">Breadcrumb</h1>
        </div>
    </div>
    <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
    <h2>Breadcrumbs Component Use Case 1</h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer1" [ariaLabel]="iconLable" [isLastLinkClickable]="true" [isLinksClickable]="false" [linksData]="linksData" [numberOfLinksVisible]="numberOfLinksVisible1"></maced-breadcrumbs>

    <h2>Breadcrumbs Component Use Case 2</h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer2" [ariaLabel]="iconLable" [linksData]="linksData"></maced-breadcrumbs>
    
    <h2>Breadcrumbs Component Use Case 3: Spanish Language</h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer3" [ariaLabel]="iconLable" [linksData]="linksData3" [numberOfLinksVisible]="numberOfLinksVisible3"></maced-breadcrumbs>
    
    <h2>Breadcrumbs Component Use Case 4: Hindi Language</h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer4" [ariaLabel]="iconLable" [linksData]="linksData4" [numberOfLinksVisible]="numberOfLinksVisible3"></maced-breadcrumbs>

    <h2>Breadcrumbs Component Use Case 5: Slash Icon</h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer5" [ariaLabel]="iconLable" [nextIconClass]="nextIconClass" [linksData]="linksData" [numberOfLinksVisible]="numberOfLinksVisible3"></maced-breadcrumbs>

    <h2>Breadcrumbs Component Use Case 6: Non Clickable Links</h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer6" [ariaLabel]="iconLable" [isLinksClickable]="isLinksClickable" [linksData]="linksData"></maced-breadcrumbs>

    <h2>Breadcrumbs Component Use Case 7: Non Clickable Links</h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer7" [ariaLabel]="iconLable" [isLinksClickable]="isLinksClickable" [nextIconClass]="nextIconClass" [linksData]="linksData"></maced-breadcrumbs>

    <h2>Breadcrumbs Component Use Case 8: Show All Links</h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer8" [ariaLabel]="iconLable" [numberOfLinksVisible]="numberOfLinksVisible8" [linksData]="linksData8"></maced-breadcrumbs>
    
    <h2>Breadcrumbs Component Use Case 9: Show All Links</h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer9" [ariaLabel]="iconLable" [nextIconClass]="nextIconClass"  [numberOfLinksVisible]="numberOfLinksVisible8" [linksData]="linksData8"></maced-breadcrumbs>

    <h2>Breadcrumbs Component Use Case 10: Show ellipse(...) for breadcrumb limit 20</h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer10" [ariaLabel]="iconLable" [isLinksClickable]="isLinksClickable" [numberOfLinksVisible]="numberOfLinksVisible8" [breadCrumbLimit]= 'breadCrumbLimit' [linksData]="linksData10"></maced-breadcrumbs>

    <h2>Breadcrumbs Component Use Case 11: Show ellipse(...) for all links with breadcrumb limit 20 </h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer11" [ariaLabel]="iconLable" [numberOfLinksVisible]="numberOfLinksVisible8" [breadCrumbLimit]= 'breadCrumbLimit' [linksData]="linksData10"></maced-breadcrumbs>
    
    <h2>Breadcrumbs Component Use Case 10: Show ellipse(...) for breadcrumb limit 20</h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer12" [ariaLabel]="iconLable" [nextIconClass]="nextIconClass"  [isLinksClickable]="isLinksClickable" [numberOfLinksVisible]="numberOfLinksVisible8" [breadCrumbLimit]= 'breadCrumbLimit' [linksData]="linksData10"></maced-breadcrumbs>

    <h2>Breadcrumbs Component Use Case 11: Show ellipse(...) for all links with breadcrumb limit 20 </h2>
    <maced-breadcrumbs [id]="breadcrumbsContainer13" [ariaLabel]="iconLable" [nextIconClass]="nextIconClass" [numberOfLinksVisible]="numberOfLinksVisible8" [breadCrumbLimit]= 'breadCrumbLimit' [linksData]="linksData10" [isUlStructure]="false"></maced-breadcrumbs>

</div>